module.exports = __webpack_public_path__ + "static/media/vu.3b3fcfb4.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/vu.svg
// module id = 973
// module chunks = 0